export default __webpack_public_path__ + "static/media/downArrow.f342b09d.svg";